module.exports = __webpack_public_path__ + "static/twitterSummaryX-70b11137df089b537383b4f4fa3dfc33.jpg";